<template>
    <div>
        <v-dialog v-model="dialog_barcode_preview" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
            <!-- <v-btn @click="fn_hideScanner">Hide Scanner</v-btn> -->
        <!-- </v-dialog> -->
            <v-card flat style="background:rgba(0, 0, 0, 0.5);">
                <v-toolbar flat>
                    <v-toolbar-side-icon @click="dialog_barcode_preview = false"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

                    <v-toolbar-title>Preview</v-toolbar-title>


                </v-toolbar>

                <!-- {{ scannedBarcode }} -->

               <!-- <div style="height: 100px;">
                 <v-text-field
                    label=""
                    id="id"
                    v-model="scannedBarcode"
                    placeholder=" "
                ></v-text-field>
                <v-btn color="success" @click="fn_barcodeData(scannedBarcode)">Add</v-btn>
               </div> -->

                <v-card-text class="pa-0" style="transform: translate(10%, 100%);">
                    <div class="label-preview canvas" :style="$parent.getSingleLabelPreviewStyle()">
                        
                        <!-- <div :style="getSinglePreviewContentStyle()">
                        </div> -->
                        
                        <!-- Custom Fields Display -->
                        <div v-for="(field, index) in $parent.config.customFields" class="draggable" :key="'custom-' + field.fieldName" :class="field.fieldName" :id="field.fieldName + '_' + (index + 1)" :style="$parent.getSingleCustomFieldStyle(field)">
                            <span>{{ field.fieldName != 'Text' ? $parent.fn_mapFieldValue(field.fieldName) : ''  }}{{ field.fieldName != 'Text' && field.fieldValue ? ':' : '' }}</span>
                            <span style="margin-left: 4px;" v-if="field.fieldValue">{{ field.fieldValue }}</span>
                        </div>
                    </div>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
let scannerListener;
export default{
    props:['closeDialog'],
    data(){	
		return{
			dialog_barcode_preview: false,
        }
	},
    methods:{
        openDialogWeb: function () {
            if(!this.dialog_barcode_preview){
                this.dialog_barcode_preview = true;
                // window.js_globals.fn_barcodeData = this.fn_barcodeData;
                // window.js_globals.fn_barcodeScanUSB = this.fn_barcodeScanUSB;
                // window.js_globals.fn_hideBarcodeScanner = this.fn_hideScanner;

                // if(localStorage.getItem('usb_scanner')){
                //     this.usbScanner = true;
                // }

                // // Remove Listener
                // if(scannerListener){
                //     document.removeEventListener("keydown", scannerListener);
                // }

                // let buffer = "";
                // let lastTime = Date.now();
                // let self = this;

                // scannerListener = function(e) {
                //     // alert('in');
                //     const now = Date.now();

                //     if (now - lastTime > 300) {
                //         buffer = "";
                //     }

                //     if (e.key.length === 1) {
                //         buffer += e.key;
                //     }

                //     if (e.key === "Enter") {
                //         self.fn_barcodeData(buffer);
                //         console.log("Scanned:", buffer);
                //         buffer = "";
                //     }

                //     lastTime = now;
                // }

                // // Attach listener
                // document.addEventListener("keydown", scannerListener);
            }


            // Attach listener
            // document.addEventListener("keydown", this.fn_usbScannerListener);
            // if(!this.usbScanner){
            //     this.fn_showScanner();
            // }
		},
		closeDialogWeb: function () {
			this.dialog_barcode_preview = false;

            // if(document.getElementById('s_btn')){
            //     setTimeout(() => {
            //         document.getElementById('s_btn').style.position = 'fixed';
            //         document.getElementById('s_btn').style.width = '100%';
            //     }, 500);

            //     setTimeout(() => {
            //         document.getElementById('s_btn').style.position = 'static';
            //     }, 800);
            // }

            // // Remove Listener
            // if(scannerListener){
            //     document.removeEventListener("keydown", scannerListener);
            // }
		}
    },
    // mounted: function(){
    //     window.js_globals.fn_barcodeData = this.fn_barcodeData;
    //     this.fn_showScanner();
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/barcode/dialog_barcode_preview.vue